// extracted by mini-css-extract-plugin
export default {"contact-container":"contact_contact-container__5EhPQ","socials-container":"contact_socials-container__QlOJE","contact-socials":"contact_contact-socials__w08ud"};